/**
 * AdminCollegamenti — hub centralizzato dei collegamenti ai servizi esterni.
 * Qui l'admin collega / ricollega / scollega Google (Calendar + Tasks),
 * Fatture in Cloud e Dropbox (con backup e cartelle indicizzate).
 */
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Link2 } from "lucide-react";
import GoogleConnectionsCard from "../components/GoogleConnectionsCard";
import FattureInCloudPanel from "../components/FattureInCloudPanel";
import AdminDropboxDocs from "./AdminDropboxDocs";

export default function AdminCollegamenti() {
  const [searchParams, setSearchParams] = useSearchParams();

  // Esito del ritorno OAuth Google (?calendar=connected / ?calendar=error)
  useEffect(() => {
    const cal = searchParams.get("calendar");
    if (!cal) return;
    if (cal === "connected") {
      toast.success("Google collegato con successo");
    } else if (cal === "error") {
      toast.error(`Errore collegamento Google: ${searchParams.get("reason") || "sconosciuto"}`);
    }
    const p = new URLSearchParams(searchParams);
    p.delete("calendar");
    p.delete("reason");
    p.delete("email");
    setSearchParams(p, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <div className="space-y-8" data-testid="admin-collegamenti-page">
      <div>
        <div className="text-[11px] tracking-[0.3em] uppercase text-gold inline-flex items-center gap-2">
          <Link2 size={13} /> Collegamenti
        </div>
        <h2 className="font-display text-2xl text-ink mt-1">Servizi collegati</h2>
        <p className="text-sm text-slate1 mt-1 max-w-2xl">
          Collega, ricollega e scollega qui tutti i servizi esterni: Google (Calendar e Tasks),
          Fatture in Cloud e Dropbox. Le funzioni (calendario, todo, ricerca documenti) restano
          dove sono nell&apos;app.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        <GoogleConnectionsCard />
        <FattureInCloudPanel />
      </div>

      <div className="border-t border-ink/10 pt-6">
        <AdminDropboxDocs />
      </div>
    </div>
  );
}
